// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import EnquiryFormController from "./enquiry_form_controller"
application.register("enquiry-form", EnquiryFormController)

import AccordionDropdownController from "./accordion_dropdown_controller"
application.register("accordion-dropdown", AccordionDropdownController)

import AddressModalController from "./address_modal_controller"
application.register("address-modal", AddressModalController)

import AddressModeController from "./address_mode_controller"
application.register("address-mode", AddressModeController)

import BusinessDetailsController from "./business_details_controller"
application.register("business-details", BusinessDetailsController)

import AddressSummaryController from "./address_summary_controller"
application.register("address-summary", AddressSummaryController)

import Admin__AdminLayoutController from "./admin/admin_layout_controller"
application.register("admin--admin-layout", Admin__AdminLayoutController)

import Admin__ArrayManagerController from "./admin/array_manager_controller"
application.register("admin--array-manager", Admin__ArrayManagerController)

import Admin__AuthLayoutController from "./admin/auth_layout_controller"
application.register("admin--auth-layout", Admin__AuthLayoutController)

import Admin__BlogPublicationController from "./admin/blog_publication_controller"
application.register("admin--blog-publication", Admin__BlogPublicationController)

import Admin__ClipboardController from "./admin/clipboard_controller"
application.register("admin--clipboard", Admin__ClipboardController)

import Admin__CopywritingUrlController from "./admin/copywriting_url_controller"
application.register("admin--copywriting-url", Admin__CopywritingUrlController)

import Admin__DashboardLayoutController from "./admin/dashboard_layout_controller"
application.register("admin--dashboard-layout", Admin__DashboardLayoutController)

import Admin__DeleteConfirmationController from "./admin/delete_confirmation_controller"
application.register("admin--delete-confirmation", Admin__DeleteConfirmationController)

import Admin__DropdownController from "./admin/dropdown_controller"
application.register("admin--dropdown", Admin__DropdownController)

import Admin__FormController from "./admin/form_controller"
application.register("admin--form", Admin__FormController)

import Admin__GalleryItemSorterController from "./admin/gallery_item_sorter_controller"
application.register("admin--gallery-item-sorter", Admin__GalleryItemSorterController)

import Admin__ImageCropperController from "./admin/image_cropper_controller"
application.register("admin--image-cropper", Admin__ImageCropperController)

import Admin__MediaHubDrawerController from "./admin/media_hub_drawer_controller"
application.register("admin--media-hub-drawer", Admin__MediaHubDrawerController)

import Admin__MediaUploadController from "./admin/media_upload_controller"
application.register("admin--media-upload", Admin__MediaUploadController)

import Admin__MenuItemFormController from "./admin/menu_item_form_controller"
application.register("admin--menu-item-form", Admin__MenuItemFormController)

import Admin__MenuSorterController from "./admin/menu_sorter_controller"
application.register("admin--menu-sorter", Admin__MenuSorterController)

import Admin__NavigationSorterController from "./admin/navigation_sorter_controller"
application.register("admin--navigation-sorter", Admin__NavigationSorterController)

import Admin__NavigationWorkspaceController from "./admin/navigation_workspace_controller"
application.register("admin--navigation-workspace", Admin__NavigationWorkspaceController)

import Admin__NotificationController from "./admin/notification_controller"
application.register("admin--notification", Admin__NotificationController)

import Admin__PageBuilderController from "./admin/page_builder_controller"
application.register("admin--page-builder", Admin__PageBuilderController)

import Admin__PageDrawerController from "./admin/page_drawer_controller"
application.register("admin--page-drawer", Admin__PageDrawerController)

import Admin__PageDrawerFormController from "./admin/page_drawer_form_controller"
application.register("admin--page-drawer-form", Admin__PageDrawerFormController)

import Admin__PageOverrideFormController from "./admin/page_override_form_controller"
application.register("admin--page-override-form", Admin__PageOverrideFormController)

import Admin__PageSorterController from "./admin/page_sorter_controller"
application.register("admin--page-sorter", Admin__PageSorterController)

import Admin__PasswordToggleController from "./admin/password_toggle_controller"
application.register("admin--password-toggle", Admin__PasswordToggleController)

import Admin__PodPreviewController from "./admin/pod_preview_controller"
application.register("admin--pod-preview", Admin__PodPreviewController)

import Admin__PodDefinitionFormController from "./admin/pod_definition_form_controller"
application.register("admin--pod-definition-form", Admin__PodDefinitionFormController)

import Admin__PodEmbedPickerController from "./admin/pod_embed_picker_controller"
application.register("admin--pod-embed-picker", Admin__PodEmbedPickerController)

import Admin__PodSorterController from "./admin/pod_sorter_controller"
application.register("admin--pod-sorter", Admin__PodSorterController)

import Admin__ProductPickerController from "./admin/product_picker_controller"
application.register("admin--product-picker", Admin__ProductPickerController)

import Admin__SectionElementSorterController from "./admin/section_element_sorter_controller"
application.register("admin--section-element-sorter", Admin__SectionElementSorterController)

import Admin__SectionWorkspaceController from "./admin/section_workspace_controller"
application.register("admin--section-workspace", Admin__SectionWorkspaceController)

import Admin__TagAutocompleteController from "./admin/tag_autocomplete_controller"
application.register("admin--tag-autocomplete", Admin__TagAutocompleteController)

import Admin__TinymceController from "./admin/tinymce_controller"
application.register("admin--tinymce", Admin__TinymceController)

import AsideMenuController from "./aside_menu_controller"
application.register("aside-menu", AsideMenuController)

import AuthFormToggleController from "./auth_form_toggle_controller"
application.register("auth-form-toggle", AuthFormToggleController)

import CartFormController from "./cart_form_controller"
application.register("cart-form", CartFormController)

import CartAsideController from "./cart_aside_controller"
application.register("cart-aside", CartAsideController)

import CartProcessingController from "./cart_processing_controller"
application.register("cart-processing", CartProcessingController)

import ContactDetailsController from "./contact_details_controller"
application.register("contact-details", ContactDetailsController)

import CustomerRegistrationController from "./customer_registration_controller"
application.register("customer-registration", CustomerRegistrationController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import CouponFormController from "./coupon_form_controller"
application.register("coupon-form", CouponFormController)

import CustomModalController from "./custom_modal_controller"
application.register("custom-modal", CustomModalController)

import DisableOnSubmitController from "./disable_on_submit_controller"
application.register("disable-on-submit", DisableOnSubmitController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FaqsController from "./faqs_controller"
application.register("faqs", FaqsController)

import FilterToggleController from "./filter_toggle_controller"
application.register("filter-toggle", FilterToggleController)

import GoogleAddressController from "./google_address_controller"
application.register("google-address", GoogleAddressController)

import HideOnScrollController from "./hide_on_scroll_controller"
application.register("hide-on-scroll", HideOnScrollController)

import HikeGalleryController from "./hike_gallery_controller"
application.register("hike-gallery", HikeGalleryController)

import InfiniteProductScrollerController from "./infinite_product_scroller_controller"
application.register("infinite-product-scroller", InfiniteProductScrollerController)

import JarallaxController from "./jarallax_controller"
application.register("jarallax", JarallaxController)

import LoadingButtonController from "./loading_button_controller"
application.register("loading-button", LoadingButtonController)

import MenuDropdownController from "./menu_dropdown_controller"
application.register("menu-dropdown", MenuDropdownController)

import ModalBlockerController from "./modal_blocker_controller"
application.register("modal-blocker", ModalBlockerController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import NavigationMenuController from "./navigation_menu_controller"
application.register("navigation-menu", NavigationMenuController)

import NavigationSubmenuController from "./navigation_submenu_controller"
application.register("navigation-submenu", NavigationSubmenuController)

import NotificationCarouselController from "./notification_carousel_controller"
application.register("notification-carousel", NotificationCarouselController)

import OrderReturnController from "./order_return_controller"
application.register("order-return", OrderReturnController)

import ParallaxController from "./parallax_controller"
application.register("parallax", ParallaxController)

import ParrallaxController from "./parrallax_controller"
application.register("parrallax", ParrallaxController)

import PasswordShowController from "./password_show_controller"
application.register("password-show", PasswordShowController)

import PaymentMethodSyncController from "./payment_method_sync_controller"
application.register("payment-method-sync", PaymentMethodSyncController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import ProductFilterController from "./product_filter_controller"
application.register("product-filter", ProductFilterController)

import ProductCardController from "./product_card_controller"
application.register("product-card", ProductCardController)

import ProductGalleryController from "./product_gallery_controller"
application.register("product-gallery", ProductGalleryController)

import ResponsiveAsideController from "./responsive_aside_controller"
application.register("responsive-aside", ResponsiveAsideController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import ProductSearchController from "./product_search_controller"
application.register("product-search", ProductSearchController)

import RangeSliderController from "./range_slider_controller"
application.register("range-slider", RangeSliderController)

import SideScrollerController from "./side_scroller_controller"
application.register("side-scroller", SideScrollerController)

import SizeQuantityController from "./size_quantity_controller"
application.register("size-quantity", SizeQuantityController)

import StaggeredFadeInController from "./staggered_fade_in_controller"
application.register("staggered-fade-in", StaggeredFadeInController)

import StickyTopController from "./sticky_top_controller"
application.register("sticky-top", StickyTopController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ScheduledPopupController from "./scheduled_popup_controller"
application.register("scheduled-popup", ScheduledPopupController)
